import { render, staticRenderFns } from "./FinishRegistration.vue?vue&type=template&id=3efc0b24"
import script from "./FinishRegistration.vue?vue&type=script&lang=js"
export * from "./FinishRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports